export function functionRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_FUNCTION_START":           
        case "FETCH_FUNCTIONS_START":                                 
        case "UPDATE_FUNCTION_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_FUNCTION_FULFILLED":           
        case "FETCH_FUNCTIONS_FULFILLED":                                 
        case "UPDATE_FUNCTION_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_FUNCTION_ERROR":
        case "FETCH_FUNCTIONS_ERROR":
        case "UPDATE_FUNCTION_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}